//src/pages/HomeGrowth.jsx
import { useNavigate } from "react-router-dom";



export default function HomeGrowth() {


  const navigate = useNavigate();

 

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        fontFamily: "Inter, sans-serif",
        color: "#111827",
      }}
    >
      {/* HERO */}
      <section
        style={{
          padding: "80px 20px 60px",
          textAlign: "center",
          background:
            "linear-gradient(to bottom, #ffffff, #f8fafc)",
        }}
      >
        <div
          style={{
            maxWidth: 900,
            margin: "0 auto",
          }}
        >
          <div
            style={{
              display: "inline-block",
              background: "#dcfce7",
              color: "#166534",
              padding: "10px 18px",
              borderRadius: 999,
              fontWeight: "bold",
              fontSize: 14,
              marginBottom: 18,
            }}
          >
            🔥 Nigerian Creators Are Growing With Creator Yard
          </div>

          <p
            style={{
              marginTop: 0,
              marginBottom: 30,
              color: "#6b7280",
              fontSize: 15,
            }}
          >
            We're documenting creator growth experiments in public.
          </p>

          <h1
            style={{
              fontSize: "clamp(2.5rem, 6vw, 5rem)",
              lineHeight: 1.05,
              marginBottom: 24,
              fontWeight: 900,
            }}
          >
            Get More
            <span style={{ color: "#f97316" }}>
              {" "}
              Views{" "}
            </span>
            On TIKTOK
          </h1>

          <p
            style={{
              fontSize: 20,
              maxWidth: 720,
              margin: "0 auto",
              color: "#4b5563",
              lineHeight: 1.7,
            }}
          >
            Most creators don't have a monetization problem.
            They have an attention problem.
            Creator Yard helps Nigerian creators create better content, get more views,
            build an audience, and earn support from fans.
           
          </p>

          <div
            style={{
              display: "flex",
              gap: 16,
              justifyContent: "center",
              flexWrap: "wrap",
              marginTop: 40,
            }}
          >
            <button
              onClick={() => navigate("/signup?source=growth")}
              style={{
                background: "#f97316",
                color: "#fff",
                border: "none",
                padding: "18px 30px",
                borderRadius: 14,
                fontWeight: "bold",
                fontSize: 18,
                cursor: "pointer",
                boxShadow:
                  "0 10px 25px rgba(249,115,22,0.25)",
              }}
            >
              🚀 Start Growing
            </button>

            <button
              onClick={() => navigate("/login")}
              style={{
                background: "#fff",
                color: "#111827",
                border: "2px solid #e5e7eb",
                padding: "18px 30px",
                borderRadius: 14,
                fontWeight: "bold",
                fontSize: 18,
                cursor: "pointer",
              }}
            >
              ▶ Creator Login
            </button>
          </div>
        </div>
      </section>

      {/* SOCIAL PROOF */}
      <section
        style={{
          padding: "20px",
          maxWidth: 1100,
          margin: "0 auto",
        }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 24,
            padding: 30,
            border: "1px solid #e5e7eb",
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(220px,1fr))",
            gap: 20,
            boxShadow:
              "0 10px 30px rgba(0,0,0,0.04)",
          }}
        >
          <div>
            <h2
              style={{
                fontSize: 32,
                margin: 0,
              }}
            >
              🔥 Real Growth
            </h2>

            <p style={{ color: "#6b7280" }}>
              Learn what content works
            </p>
          </div>

          <div>
            <h2
              style={{
                fontSize: 32,
                margin: 0,
              }}
            >
              📈 Get More Views
            </h2>

            <p style={{ color: "#6b7280" }}>
              Understand what attracts attention
            </p>
          </div>

          <div>
            <h2
              style={{
                fontSize: 32,
                margin: 0,
              }}
            >
              🇳🇬 Built For Nigeria
            </h2>

            <p style={{ color: "#6b7280" }}>
              Designed for Nigerian TikTok creators
            </p>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section
        style={{
          padding: "90px 20px",
          maxWidth: 1200,
          margin: "0 auto",
        }}
      >
        <div
          style={{
            textAlign: "center",
            marginBottom: 60,
          }}
        >
          <h2
            style={{
              fontSize: 48,
              marginBottom: 14,
            }}
          >
            How Creator Yard works
          </h2>

          <p
            style={{
              color: "#6b7280",
              fontSize: 18,
            }}
          >
            Growth comes before monetization.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(280px,1fr))",
            gap: 25,
          }}
        >
          {[
            {
              emoji: "🎥",
              title: "Create Better Content",
              text:
                "Learn from real creators experiments, content frameworks, storytelling techniques, and audience psychology.",
            },
            {
              emoji: "📈",
              title: "Grow Your Audience",
              text:
                "Views become followers. Followers becomes fans. Every creator starts with attention.",
            },
            {
              emoji: "💸",
              title: "Receive Direct Support",
              text:
                "Once People trust your work, support becomes natural. Monietization follows growth.",
            },
          ].map((item, i) => (
            <div
              key={i}
              style={{
                background: "#fff",
                borderRadius: 24,
                padding: 30,
                border: "1px solid #e5e7eb",
                boxShadow:
                  "0 8px 20px rgba(0,0,0,0.04)",
              }}
            >
              <div
                style={{
                  fontSize: 40,
                  marginBottom: 20,
                }}
              >
                {item.emoji}
              </div>

              <h3
                style={{
                  fontSize: 24,
                  marginBottom: 12,
                }}
              >
                {item.title}
              </h3>

              <p
                style={{
                  color: "#6b7280",
                  lineHeight: 1.7,
                }}
              >
                {item.text}
              </p>
            </div>
          ))}
        </div>

        {/* CREATOR GUIDANCE */}
        <div
          style={{
            marginTop: 50,
            background: "#fff7ed",
            border: "1px solid #fed7aa",
            padding: 30,
            borderRadius: 24,
            textAlign: "center",
          }}
        >
          <h3
            style={{
              fontSize: 28,
              marginBottom: 14,
            }}
          >
            🎯 Why Views Matter
          </h3>

          <p
            style={{
              color: "#6b7280",
              lineHeight: 1.8,
              maxWidth: 700,
              margin: "0 auto",
              fontSize: 17,
            }}
          >
            No creator starts with supporters
            <br />
            <br />
            “Every creator starts with attention .”
            <br />
            <br />
            The creators receiving support today first learned how to:

            <br />
            • Get views
            <br />
            • Build trust
            <br />
            • Stay consistent
            <br />
            • Create content people care about.
            <br />
            <br />

            Support is usually a result of audience growth, not the starting point.
          </p>

          
        </div>
      </section>

      {/* FIRST MONEY SECTION */}
      <section
        style={{
          background: "#111827",
          color: "#fff",
          padding: "90px 20px",
        }}
      >
        <div
          style={{
            maxWidth: 1100,
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(320px,1fr))",
            gap: 40,
            alignItems: "center",
          }}
        >
          <div>
            <div
              style={{
                display: "inline-block",
                background: "#f97316",
                padding: "10px 18px",
                borderRadius: 999,
                marginBottom: 20,
                fontWeight: "bold",
              }}
            >
              🔥 Creator Yard Experiment
            </div>

            <h2
              style={{
                fontSize: 48,
                lineHeight: 1.1,
                marginBottom: 20,
              }}
            >
              3,400+ People Watch One of Our Videos 
            </h2>

            <p
              style={{
                color: "#d1d5db",
                lineHeight: 1.8,
                fontSize: 18,
              }}
            >
                We recently edited and published a political video that reached over 3,400 viewers on Facebook.

                What did we learn?

                Attention comes first.

                Monetization comes second.

                Before people support a creator, they need to discover them.

                Before discovery, the content must earn attention.

                That's the game we're learning publicly.
            </p>

            <a
                href="https://web.facebook.com/reel/1662382135020590"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    display: "inline-block",
                    marginTop: 24,
                    background: "#1877f2",
                    color: "#fff",
                    textDecoration: "none",
                    padding: "14px 20px",
                    borderRadius: 12,
                    fontWeight: "700",
                }}
            >
                ▶ View The Facebook Video
            </a>
          </div>

          <div
            style={{
              background: "#1f2937",
              borderRadius: 24,
              padding: 30,
              border: "1px solid #374151",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 18,
              }}
            >
              {[
                "🔥 3,400+ Facebook Views",
                "🏖 69+ Comments On A Single Reel",
                "🧪 Public Growth Experiments",
              ].map((text, i) => (
                <div
                  key={i}
                  style={{
                    background: "#111827",
                    padding: 18,
                    borderRadius: 16,
                    fontWeight: 600,
                  }}
                >
                  {text}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>


      {/* FACEBOOK PROOF */}
      <section
        style={{
          padding: "90px 20px",
          background: "#f8fafc",
        }}
      >
        <div
          style={{
            maxWidth: 1100,
            margin: "0 auto",
          }}
        >
          <div
            style={{
              textAlign: "center",
              marginBottom: 50,
            }}
          >
            <h2
              style={{
                fontSize: 48,
                marginBottom: 16,
              }}
            >
              📈 Real Content Experiments
            </h2>

            <p
              style={{
                color: "#6b7280",
                fontSize: 18,
                maxWidth: 700,
                margin: "0 auto",
                lineHeight: 1.8,
              }}
            >
              We don't just talk about content growth.
              We actively test content formats, study audience
              behavior, and publish the results publicly.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit,minmax(280px,1fr))",
              gap: 25,
            }}
          >
            {[
              {
                title: "Political Analysis",
                views: "3,400+ Views",
                link:
                  "https://web.facebook.com/reel/1662382135020590",
              },
              {
                title: "Creator Experiment",
                views: "1,600+ Views",
                link:
                  "https://web.facebook.com/reel/1034005359143779",
              },
              {
                title: "Audience Test",
                views: "1,100+ Views",
                link:
                  "https://web.facebook.com/reel/1755092652520210",
              },
            ].map((video, i) => (
              <a
                key={i}
                href={video.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <div
                  style={{
                    background: "#fff",
                    borderRadius: 24,
                    padding: 30,
                    border: "1px solid #e5e7eb",
                    boxShadow:
                      "0 10px 30px rgba(0,0,0,0.05)",
                    cursor: "pointer",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      fontSize: 42,
                      marginBottom: 20,
                    }}
                  >
                    🎬
                  </div>

                  <h3
                    style={{
                      fontSize: 24,
                      marginBottom: 10,
                    }}
                  >
                    {video.title}
                  </h3>

                  <div
                    style={{
                      fontSize: 34,
                      fontWeight: 900,
                      color: "#f97316",
                      marginBottom: 12,
                    }}
                  >
                    {video.views}
                  </div>

                  <p
                    style={{
                      color: "#6b7280",
                      lineHeight: 1.7,
                    }}
                  >
                    View the original Facebook reel and see the
                    results for yourself.
                  </p>
                </div>
              </a>
            ))}
          </div>

          <div
            style={{
              marginTop: 40,
              background: "#fff7ed",
              border: "1px solid #fed7aa",
              borderRadius: 24,
              padding: 30,
              textAlign: "center",
            }}
          >
            <h3
              style={{
                fontSize: 28,
                marginBottom: 16,
              }}
            >
              🎯 What We Learned
            </h3>

            <p
              style={{
                color: "#6b7280",
                lineHeight: 1.8,
                maxWidth: 800,
                margin: "0 auto",
                fontSize: 18,
              }}
            >
              Most creators focus on monetization too early.
              The real challenge is getting attention first.
              Views create discovery.
              Discovery creates trust.
              Trust eventually creates support.
            </p>
          </div>
        </div>
      </section>

      {/* TRUST */}
      <section
        style={{
          padding: "70px 20px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            maxWidth: 800,
            margin: "0 auto",
          }}
        >
          <div
            style={{
              fontSize: 18,
              fontWeight: "bold",
              marginBottom: 20,
            }}
          >
            🔒 Payments Secured by Flutterwave
          </div>

          <p
            style={{
              color: "#6b7280",
              lineHeight: 1.8,
              fontSize: 18,
            }}
          >
            Trusted payment infrastructure powering safe
            creator support payouts across Nigeria.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section
        style={{
          padding: "0 20px 100px",
        }}
      >
        <div
          style={{
            maxWidth: 1000,
            margin: "0 auto",
            background:
              "linear-gradient(to right, #f97316, #fb923c)",
            borderRadius: 32,
            padding: "70px 30px",
            textAlign: "center",
            color: "#fff",
          }}
        >
          <h2
            style={{
              fontSize: "clamp(2rem,5vw,4rem)",
              lineHeight: 1.1,
              marginBottom: 20,
            }}
          >
            Get More Views, Build An Audience, Earn Support
          </h2>

          <p
            style={{
              fontSize: 20,
              maxWidth: 700,
              margin: "0 auto 35px",
              lineHeight: 1.7,
            }}
          >
            Creator Yard helps creators focus on what matters first:
            Attention.
            Because every supporter starts as a viewer.
          </p>

          <button
            onClick={() => navigate("/signup?source=growth")}
            style={{
              background: "#fff",
              color: "#111827",
              border: "none",
              padding: "18px 30px",
              borderRadius: 14,
              fontWeight: "bold",
              fontSize: 18,
              cursor: "pointer",
            }}
          >
            🚀 Start Growing Today
          </button>
        </div>
      </section>
    </div>
  );
}